import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, NavLink} from "react-router-dom";
import {BrowserView, MobileView, isBrowser, isMobile} from 'react-device-detect';
import {Link, DirectLink, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import Header from './header.jsx'
import Landing from './landing.jsx'

var timer = false;
var minScrollForce = false;
var sections = [];

class Footer extends Component {

  constructor (props) {
    super(props)
    this.state = {addClass: false}
  }

  toggle() {
    this.setState({addClass: !this.state.addClass});
  }
  handleClick() {
    setState({addClass: !this.state.addClass});
  }

  render() {
    const toggleMenu = ["hamburger"];
    const openMenu = ["mobile-menu"];

    if(this.state.addClass) {
      toggleMenu.push('is-active');
      openMenu.push('open');
    }

    return (
      <footer id="footer">
        <BrowserView device={isBrowser}>
          <Header/>
        </BrowserView>
        <div className="footer-items">
          <div className="footer-left">
            <p>Mezzanine Office, The George, Ball Street, Paceville, St Julian’s STJ 3123, Malta.</p>
            <br />
            <div className="copyright">© Prozone Ltd.</div>
          </div>
          <div className="footer-right">
            <a href="https://www.linkedin.com/company/bethard-group-ltd-/" target="_blank"><i className="fab fa-linkedin-in"></i></a>
            <a href="https://www.instagram.com/betharduniverse/" target="_blank"><i className="fab fa-instagram"></i></a>
            <a href="https://www.youtube.com/channel/UCvv3HwkoTaly4o1FzeGP8Lw/featured" target="_blank"><i className="fab fa-youtube"></i></a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./client/components/footer.jsx